export function formatReminderTableDate(isoDate: string) {
  const d = new Date(isoDate);
  if (Number.isNaN(d.getTime())) return isoDate;
  return d.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

export function formatReminderTableTime(isoDate: string, timezone?: string) {
  const d = new Date(isoDate);
  if (Number.isNaN(d.getTime())) return '';

  const time = d.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    ...(timezone ? { timeZone: timezone } : {}),
  });

  return timezone ? `${time} (${timezone})` : time;
}
